import React from 'react';

export default function NumberPad({ value, onChange, maxLength = 9 }) {
  // 現在 NumberPad 不再處理邏輯，只把 key 送出去
  // onChange 參數會是：'0'..'9'、'00'、或 'del'
  const btnStyle = {
    width:  40,
    height: 40,
    fontSize: 16,
    cursor: 'pointer',
  };

  const keys = ['1','2','3','4','5','6','7','8','9','00','0'];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 4,
      marginTop: 6,
      maxWidth: `${3 * btnStyle.width + 2 * 4}px`
    }}>
      {keys.map(key => (
        <button
          key={key}
          style={btnStyle}
          onClick={() => onChange?.(key)}
        >
          {key}
        </button>
      ))}
      <button
        style={{
          ...btnStyle,
          background: '#f3f3f3',
          border: '2px solid #000',
        }}
        onClick={() => onChange?.('del')}
        title="刪除一位"
      >
        ⌫
      </button>
    </div>
  );
}
